module.exports = __webpack_public_path__ + "static/media/forex_sport.d2ed915f.png";